import { getPara, loadScript } from "./util";
import CallApp from 'callapp-lib';
import getEnv from '@/utils/env'

let ua = typeof navigator !== 'undefined' && navigator.userAgent || '', isIOS = /(iPhone|iPad|iPod|iOS|iTouch)/i.test(ua)
let isInWx = ua.match(/MicroMessenger/i);
declare const wx:any
let timeout:number|null = null;
let isWxReady = false;
export function launchOrDownload(app: any, downloadFun?: any){
	if(isIOS){
		console.log('IOS launch url:', app.scheme+(app.schemeLaunchParam||""), navigator.userAgent)
		typeof window !== 'undefined' && (window.location.href = app.scheme+(app.schemeLaunchParam||""));
		var clickedAt = +new Date;
		setTimeout(function(){
			if (+new Date - clickedAt < 2000){
				typeof window !== 'undefined' && (window.location.href = app.downloadUrlIos||app.downloadUrl);
			}
		}, 600);
	}else{
		sendRequest(app.scheme+(app.schemeLaunchParam||""));
		console.log('launch url:', app.scheme+(app.schemeLaunchParam||""))
		setTimeout(downloadFun||function(){
			console.log('download url:', app.downloadUrl);
			typeof window !== 'undefined' && (window.location.href = app.downloadUrlAnd||app.downloadUrl);
		},3000)
	}
}

function sendRequest(url: string){
  if (typeof document ==='undefined') return;
	var ifr = document.createElement('iframe');
	ifr.src = url;
  console.log('lanch app: ', url);
	ifr.style.cssText = "display:none;width:0;height:0";
	document.body.appendChild(ifr);
	setTimeout(function(){
		document.body.removeChild(ifr);
	},3000)
}


function initWxConfig() {
  wx.config({
    beta: true,
    debug: false,
    appId: "",
    timestamp: "",
    nonceStr: "hpydapp",
    signature: "",
    jsApiList: [
      "showOptionMenu",
      "getInstallState",
      "launch3rdApp",
      "shareTimeline",
      "shareWeibo",
      "sendAppMessage",
      "shareQQ",
      "shareQZone"
    ]
  });
  wx.ready(() => { isWxReady = true });
}

export async function init() {
  if(isInWx) await loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')
  if (isInWx) initWxConfig()
    else {
      if (typeof document === 'undefined') {
        return;
      }
      let hiddenProperty = 'hidden' in document ? 'hidden' : ('webkitHidden' in document ? 'webkitHidden' : ('mozHidden' in document ? 'mozHidden' : ''));
      let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
      let onVisibilityChange = function() {
        if (hiddenProperty && (document as any)[hiddenProperty]) {
          timeout && clearTimeout(timeout);
        }
      };
      document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    }
}

export function handleOpenApp(app: any) {
  const openUrl = app.scheme+(app.schemeLaunchParam||"");
  if (isInWx) {
    let launchWxApp = function () {
      if (isIOS) {
        wx && wx.invoke('launchApplication', {
          "schemeUrl": encodeURI(openUrl)
        }, function (res: any) {
          if (!res || res.err_msg != 'launchApplication:ok' ) {
            typeof location !== 'undefined' && (location.href = app.downloadUrlIos||app.downloadUrl);
          }
        });
      } else {
        console.log('wx.invoke opnUrl:', encodeURI(openUrl));
        wx && wx.invoke('launchApplication', {
          "schemeUrl": encodeURI(openUrl)
        }, function (res: any) {
          console.log('wx.invoke res:', res);
          if (!res || res.err_msg != 'launchApplication:ok' ) {
            typeof location !== 'undefined' &&  (location.href = app.downloadUrlAnd||app.downloadUrl);
          }
        });
      }
    }
    let int = setInterval(function () {
      if (isWxReady) {
        clearInterval(int)
        launchWxApp()
      }
    }, 50)
    console.log('wx is ready: ', isWxReady);
  } else {
    const options = {
      scheme: {
        protocol: app.schemeOnly,
      },
      intent: {
        scheme: app.schemeOnly,
        package: getPara('pre', typeof location !== 'undefined' && location.href || '') ? 'com.tencent.igce' : 'com.tencent.ig',
      },
      appstore: 'https://apps.apple.com/us/app/pubg-mobile-traverse/id1330123889',
      timeout: 3000,
      fallback: app.downloadUrl,
      logFunc: function () {
        if (typeof document === 'undefined') {
          return;
        }
        // fail
        let ifr = document.createElement("iframe");
        ifr.setAttribute('src', openUrl);
        ifr.setAttribute('style', 'display:none');
        document.body.appendChild(ifr);
        let startTime = (new Date).valueOf();
        timeout = setTimeout(function () {
          let endTime = (new Date).valueOf();
          if (endTime - startTime < 1550) {
            document.body.removeChild(ifr);
            location.href = app.downloadUrl;
          }
        }, 2000);
      },
    };
    const callLib = new CallApp(options as any);
    console.log("***claaLib app:", app, " options:", options);
    callLib.open({
      param: app.params,
      path: app.path,
    });
  }
}

